import OrderLoader from './OrderLoader';

export default OrderLoader;
